import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";
import { FirebaseService } from "./services/firebase.service";

// We need a single Instance through the application
const firebaseService = new FirebaseService();

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/admin" render={props => <AdminLayout firebaseSvc={firebaseService} {...props} />} />
      <Route path="/auth" render={props => <AuthLayout firebaseSvc={firebaseService} {...props} />} />
      <Redirect from="/" to="/admin/index" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
